import { getCommonAnalytics } from "./common-analytics";

export interface PushStepEventParams {
	event: string;
	step: string;
	stepName: string;
}

export function pushStepEvent({
	event,
	step,
	stepName
}: PushStepEventParams): void {
	getCommonAnalytics()?.events.pushStepEvent?.(event, step, stepName);
}
